function toNonExponential(num) {
    var m = num.toExponential().match(/\d(?:.(\d*))?e([+-]\d+)/);
    return num.toFixed(Math.max(0, (m[1] || "").length - m[2]));
}
/**
 * @description: 整数、0、小数显示规则
 * @param  {*} number:需要处理的数字；
 * @return {*} 转换格式后的数据 1,000
 */
export function ShowHandleNumber(number, total) {
    if (Number(number) === 0) {
        return 0;
    }
    if (Number.isInteger(number) || !String(number).includes('.') || Number.isInteger(Number(number))) {
        return Number(number).toLocaleString();
    }
    else {
        let testNum = Number(number);
        const numStr = toNonExponential(testNum);
        if (numStr.includes('.')) {
            const [integerPart, decimalPart] = numStr.split('.');
            let formattedNumber = Number(Number(integerPart) + '.' +
                decimalPart.slice(0, total)) + '';
            if (!formattedNumber.includes('.')) {
                return formattedNumber.toLocaleString();
            }
            else {
                const [integerPart1, decimalPart1] = formattedNumber.split('.');
                let result = Number(integerPart1).toLocaleString() +
                    '.' +
                    decimalPart1.slice(0, total);
                return result;
            }
        }
    }
}
